import App from './App.tsx'
import './styles/globals.css'
import { createRoot } from 'react-dom/client'
// Initialize token refresh interceptors
import '@/services/tokenRefresh.service'

createRoot(document.getElementById('root')!).render(
    <App />
)